var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"text-h6 q-pa-xs"},[_vm._v(_vm._s(_vm.player.displayName || '???'))]),_c('player-dash-board',{attrs:{"keyeded-latest-weekly":_vm.keyededLatestWeekly}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }